import React, { Component } from 'react';
import CustomLoader from '../../common/Loader';

class SourceApi extends Component {
	constructor(props) {
		super(props);

		this.state = {
			DataSource_ID: this.props.DataSource_ID,
			Description: '',
			URL: '',
			Client_ID: '',
			Password: '',
			Username: '',
			loading: false,
		};
	}

	render() {
		const { Client_ID, Description, loading, Password, Username, URL } = this.state;
		if (loading) {
			return <CustomLoader loading={loading} />;
		}

		return (
			<React.Fragment>
				<div class='form-group'>
					<label class='small' for='Description'>
						Source Description
					</label>
					<input class='form-control' id='Description' type='text' name='Description' value={Description} onChange={(e) => this.handleChange(e.target)} />
				</div>

				<div class='form-group'>
					<label class='small' for='url'>
						API Url
					</label>
					<input class='form-control' id='url' type='text' name='URL' value={URL} onChange={(e) => this.handleChange(e.target)} />
				</div>

				<div class='form-group'>
					<label class='small' for='Client_ID'>
						API Client ID
					</label>
					<input class='form-control' id='Client_ID' type='text' name='Client_ID' value={Client_ID} onChange={(e) => this.handleChange(e.target)} />
				</div>

				<div class='form-group'>
					<label class='small' for='Password'>
						API Password
					</label>
					<input class='form-control' id='Password' type='text' name='Password' value={Password} onChange={(e) => this.handleChange(e.target)} />
				</div>

				<div class='form-group'>
					<label class='small' for='Username'>
						API Username (optional)
					</label>
					<input class='form-control' id='Username' type='text' name='Username' value={Username} onChange={(e) => this.handleChange(e.target)} />
				</div>

				<hr className='my-4' />
				<div className='d-flex justify-content-end'>
					<button className='btn btn-outline-primary' type='button'>
						Save
					</button>
				</div>
			</React.Fragment>
		);
	}
}

export default SourceApi;
